var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classObject},[_c('video',{attrs:{"id":_vm.id,"autoplay":_vm.autoplay,"controls":_vm.controls}})])
}
var staticRenderFns = []

export { render, staticRenderFns }